import { Home } from "creso-core/api";
import { CresoEvent } from "creso-core/types";
import { useQueries } from "@tanstack/react-query";
import { useMemo } from "react";

export function useFamilyMemberEvents(clientIds: number[], date: string) {
  const eventQueries = useQueries({
    queries: clientIds.map((clientId) => ({
      queryKey: ["events", date, clientId],
      queryFn: () => Home.getEvents({ date, clientId }),
      enabled: clientIds.length > 0 && !!date,
    })),
  });

  const data = useMemo(
    () => eventQueries.flatMap((query) => query.data ?? []) as CresoEvent[],
    [eventQueries]
  );

  const isLoading = eventQueries.some((query) => query.isLoading);

  return { data, isLoading };
}

export function useFamilyMemberPendingEvents(clientIds: number[]) {
  const pendingQueries = useQueries({
    queries: clientIds.map((clientId) => ({
      queryKey: ["events", "pending", clientId],
      queryFn: () => Home.getPendingEvents(clientId),
      enabled: clientIds.length > 0,
    })),
  });

  const data = useMemo(
    () => pendingQueries.flatMap((query) => query.data ?? []) as CresoEvent[],
    [pendingQueries]
  );

  const isLoading = pendingQueries.some((query) => query.isLoading);

  return { data, isLoading };
}
